/**
 * Utility function to resolve image URLs
 * Handles both relative paths (/api/uploads/...) and full URLs (https://...)
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (url) => {
  if (!url) return null;
  
  // If it's already a full URL (starts with http:// or https://), use as-is
  // But check if it's from an old/different domain that might be broken
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Check if it's a local upload from a different domain
    if (url.includes('/api/uploads/')) {
      // Extract the relative path and use current backend
      const relativePath = url.substring(url.indexOf('/api/uploads/'));
      return `${BACKEND_URL}${relativePath}`;
    }
    // External URL (like Unsplash), use as-is
    return url;
  }
  
  // Relative path - prepend current backend URL
  if (url.startsWith('/api/') || url.startsWith('/uploads/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Fallback - return as-is
  return url;
};

export default resolveImageUrl;
